import BossModel from "@/models/BossModel";
import constants from '@/constants';
import Country from '@/models/Country/Country'
import User from '@/models/User/User'
import Relative from "@/models/Customer/Relative/Relative";
import Address from "@/models/Customer/Address/Address";
import Message from "@/models/Message/Message";
import orderBy from 'lodash/orderBy';
import Tag from "@/models/Customer/Tag/Tag";
import CustomerCustomerTag from "@/models/Customer/CustomerCustomerTag";
import MarketingChannel from "@/models/Customer/MarketingChannel/MarketingChannel";
import Company from "@/models/Company/Company";
import Traveller from "@/models/Customer/Traveller/Traveller";
import TelephoneNumber from "@/models/Customer/TelephoneNumber/TelephoneNumber.js";

export default class Customer extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'customer';

    /**
     *
     * @type {string}
     */
    static entity = 'customers';

    static fields() {
        return {
            id: this.number(null).nullable(),
            firstname: this.attr(null),
            lastname: this.attr(null),
            debcode: this.attr(null),
            email: this.attr(null),
            fax: this.attr(null),
            date_of_birth: this.attr(null),
            gender_cid: this.number(0).nullable(),
            country_id: this.number(null).nullable(),
            user_id: this.number(null).nullable(),
            newsletter: this.boolean(false),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            deleted_at: this.attr(null),
            access_mijn: this.boolean(false),
            is_mine_created: this.boolean(false),
            customer_marketing_channel_id: this.number(null).nullable(),
            company_id: this.number(null).nullable(),
            country: this.belongsTo(Country, 'country_id'),
            addresses: this.hasMany(Address, 'customer_id'),
            address: this.hasOne(Address, 'customer_id'),
            company: this.belongsTo(Company, 'company_id'),
            user: this.belongsTo(User, 'user_id'),
            tags: this.belongsToMany(Tag, CustomerCustomerTag, 'customer_id', 'customer_tag_id'),
            relatives: this.hasMany(Relative, 'customer_id'),
            messages: this.hasMany(Message, 'customer_id'),
            marketingChannel: this.belongsTo(MarketingChannel, 'customer_marketing_channel_id'),
            travellers: this.hasMany(Traveller, 'customer_id'),
            telephoneNumbers: this.hasMany(TelephoneNumber, 'customer_id'),
            defaultTelephoneNumber: this.hasOne(TelephoneNumber, 'customer_id'),
        }
    }

    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(20)
            .get();
    }

    Tags() {
        return this.getRelated('tags');
    }

    Country() {
        return this.getRelated('country');
    }

    Contacts() {
        return orderBy(this.getRelated('contacts'), ['is_active', 'lastname', 'firstname'], ['desc', 'asc', 'asc']);
    }

    Addresses() {
        return this.getRelated('addresses');
    }

    Travellers() {
        return orderBy(this.getRelated('travellers.latestVersion'), ['is_active', 'lastname', 'firstname'], ['desc', 'asc', 'asc']);
    }

    Address() {
        return this.getRelated('address', function (item) {
            return item.is_default;
        });
    }

    User() {
        return this.getRelated('user');
    }

    Gender() {
        let gender = constants.genders.find(item => item.id === parseInt(this.gender_cid));
        if (gender === undefined) {
            return 'Onbekend';
        }

        return gender.label;
    }

    Relatives() {
        return orderBy(this.getRelated('relatives'), ['name']);
    }

    Messages() {
        return this.getRelated('messages');
    }

    fetchCompanyIfNecessary() {
        if (this.company_id && !this.company) {
            if (!Company.find(this.company_id)) {
                Company.api().find(this.company_id);
            }
        }
    }

    isValidCompany() {
        if (!this.company_id) {
            return true;
        }
        let company = Company.find(this.company_id);
        return company && company.kvk_number && company.vat_number;
    }
}
